"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const reactstrap_1 = require("reactstrap");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const classnames_1 = __importDefault(require("classnames"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const pageConfig_1 = require("../../store/ducks/pageConfig");
require("../../../css/components/accessibility/AcessibilidadeBar.scss");
const AccessibilityContext_1 = require("./contexts/AccessibilityContext");
const ZoomContext_1 = require("../../shared/contexts/ZoomContext");
const AppContextProvider_1 = require("../../shared/contexts/AppContextProvider");
const http_requests_1 = require("../../shared/http-requests");
const helpers_1 = require("../../shared/helpers");
const AccessibilityBar = ({ acessibilidadeRx, userSessionRx, userLocalRx, instituicaoRx: { sigla_instituicao, codEmpresa }, fromAccessibilityPages, showDarkMode = true, guiasPesquisaRx }) => {
    const isAuthenticated = userSessionRx || userLocalRx;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { faqElementRef, searchInputRef, hasFaqs, hasSearch } = (0, AccessibilityContext_1.useAccessibilityContext)();
    const { incrementZoom, resetZoom, zoom } = (0, ZoomContext_1.useZoomContext)();
    const { lang, changeLang, onGoBackMobile, headerTitle } = (0, AppContextProvider_1.useAppContext)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [optionsIsOpen, setOptionsIsOpen] = (0, react_1.useState)(false);
    const [showGoToFirstSearch, setShowGoToFirstSearch] = (0, react_1.useState)(false);
    const [showAutoatendimento, setShowAutoatendimento] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (history.location.pathname.startsWith('/pesquisa_acessibilidade')) {
            setShowGoToFirstSearch(true);
        }
        else {
            setShowGoToFirstSearch(false);
        }
    }, [history.location]);
    const firstTabObject = guiasPesquisaRx && (guiasPesquisaRx === null || guiasPesquisaRx === void 0 ? void 0 : guiasPesquisaRx.length) > 0 ? guiasPesquisaRx[0] : null;
    const handleIncrementZoom = (event) => {
        event.preventDefault();
        incrementZoom();
    };
    const handleResetZoom = (event) => {
        event.preventDefault();
        resetZoom();
    };
    const handleClickChangeContrast = (event) => {
        event.preventDefault();
        const { cor } = acessibilidadeRx;
        dispatch((0, pageConfig_1.acessibilidadeData)(Object.assign(Object.assign({}, acessibilidadeRx), { cor: cor === 'contraste' ? '' : 'contraste' })));
    };
    const handleClickDuvidasFrequentes = (event) => {
        var _a;
        event.preventDefault();
        if (pathname.startsWith('/pesquisa_acessibilidade')) {
            history.push('/pesquisa_acessibilidade/duvidas-frequentes');
        }
        (_a = faqElementRef === null || faqElementRef === void 0 ? void 0 : faqElementRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    const handleGoBack = (event) => {
        event.preventDefault();
        if (onGoBackMobile && typeof onGoBackMobile === 'function') {
            onGoBackMobile();
        }
        else {
            history.goBack();
        }
    };
    const handleFocusSearch = (event) => {
        var _a;
        event.preventDefault();
        (_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const handleClickShowOptions = (event) => {
        event.preventDefault();
        setOptionsIsOpen(true);
    };
    (0, react_1.useEffect)(() => {
        http_requests_1.ParametrosAPI.validaAutoatendimento()
            .then(response => {
            setShowAutoatendimento(response.data.showAuto);
            //setCodBibAuto(response.data.codBibAuto);
            //setAuthAuto(response.data.authAuto);
            //setIdiomaAuto(response.data.idiomaAuto);
        })
            .catch(error => helpers_1.APIHelper.tratarErro(error));
    }, [showAutoatendimento]);
    // Todo se não for necessário remover
    // const getScreenName: string = useMemo(() => {
    //     switch (pathname) {
    //         case '':
    //             return t('Inicio');
    //         case '/login':
    //             return t('AccessibilityBar.Login');
    //         case '/pesquisa_acessibilidade':
    //             return t('AccessibilityBar.PesquisaAcessibilidade');
    //         case '/plano_ensino':
    //             return t('PlanoEnsino');
    //         case '/catalogos/kids':
    //             return t('PergamumKids');
    //         case '/catalogos/museu':
    //             return t('Museu');
    //         default: {
    //             const pathName = pathname.replace(/^\//, '').toLowerCase();
    //
    //             if (pathName.startsWith('acervo')) return t('DadosAcervo');
    //
    //             if (pathName.startsWith('MeuPergamum')) return t('MeuPergamum');
    //             const arrPathNameArgs = pathName.split(/[-_]+/);
    //             return capitalizeFirstLetter(arrPathNameArgs.join(' ') ?? '');
    //         }
    //     }
    // }, [pathname]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("nav", { style: {
                position: 'sticky',
                top: 0,
                zIndex: 1040,
            }, className: "AcessibilidadeBar bg bg-degrade-mobile" },
            react_1.default.createElement("div", { className: "container-fluid py-2 d-block d-md-none bkdark50" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-2" },
                        react_1.default.createElement("a", { onClick: handleGoBack, href: `#${t('Voltar').toLowerCase()}`, accessKey: "0", title: t('Voltar'), className: "branco" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronLeft }))),
                    react_1.default.createElement("div", { className: "col-10 f700 branco" })))),
        react_1.default.createElement("nav", { className: "AcessibilidadeBar bg b-solid-bottom b-w2 b-branco70 py-1 justify-content-center d-md-flex d-none" },
            react_1.default.createElement("ul", { className: "d-flex align-items-center" }, !fromAccessibilityPages || optionsIsOpen ? (react_1.default.createElement(react_1.default.Fragment, null,
                pathname !== '/pesquisa_acessibilidade' ? (react_1.default.createElement("li", null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/pesquisa_acessibilidade", accessKey: "1" }, t('AccessibilityBar.IrParaBuscaAcessivel')))) : (''),
                hasSearch ? (react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { onClick: handleFocusSearch, href: `#${t('AccessibilityBar.IrParaABusca').toLowerCase()}`, accessKey: "2" }, t('AccessibilityBar.IrParaABusca')))) : (''),
                firstTabObject && showGoToFirstSearch ? (react_1.default.createElement("li", null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/${firstTabObject === null || firstTabObject === void 0 ? void 0 : firstTabObject.codigo}`, accessKey: "3" }, t(`AccessibilityBar.IrParaPrimeiraPesquisa`, {
                        firstSearch: firstTabObject === null || firstTabObject === void 0 ? void 0 : firstTabObject.titulo
                    })))) : '',
                !isAuthenticated && pathname !== '/login' ? (react_1.default.createElement("li", null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/login", accessKey: "4" }, t('AccessibilityBar.LogarNoSistema')))) : (''),
                hasFaqs ||
                    pathname.startsWith('/pesquisa_acessibilidade') ? (react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { onClick: handleClickDuvidasFrequentes, href: "pesquisa_acessibilidade_pergunta", accessKey: "5" }, t('DuvidasFrequentes')))) : (''),
                pathname !== '/pesquisa_acessibilidade/sobre' ? (react_1.default.createElement("li", null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/pesquisa_acessibilidade/sobre", accessKey: "6", title: t('AccessibilityBar.SobreAAcessibilidade'), className: "mr-1", rel: "nofollow" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUniversalAccess, className: "mr-1" }),
                        t('Acessibilidade')))) : (''),
                showDarkMode ? (react_1.default.createElement("li", { className: "opt-icon opt-contrast position-relative" },
                    react_1.default.createElement("a", { className: (0, classnames_1.default)({
                            'activated-accessibility-link': acessibilidadeRx.cor === 'contraste',
                        }), href: "#", accessKey: "7", title: t('AccessibilityBar.MudarOContraste'), onClick: handleClickChangeContrast },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faMoon }),
                        react_1.default.createElement("span", { "aria-hidden": "true", className: "so_para_leitores_tela" }, t('AccessibilityBar.Contraste'))))) : '',
                react_1.default.createElement("li", { className: "opt-icon opt-increase-text" },
                    react_1.default.createElement("a", { className: (0, classnames_1.default)({
                            'activated-accessibility-link': zoom > 100,
                        }), onClick: handleIncrementZoom, href: "#", accessKey: "8", title: t('AccessibilityBar.AumentarTamanhoTexto'), "aria-label": t('AccessibilityBar.AumentarTamanhoTexto') },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFont }),
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPlus }),
                        react_1.default.createElement("span", { "aria-hidden": "true", className: "so_para_leitores_tela" }, t('AccessibilityBar.AumentarOTexto')))),
                react_1.default.createElement("li", { className: "opt-icon opt-normal-text" },
                    react_1.default.createElement("a", { className: (0, classnames_1.default)({
                            'activated-accessibility-link': zoom === 100,
                        }), onClick: handleResetZoom, href: "#", accessKey: "9", title: t('AccessibilityBar.RetornarTamanhoPadraoTexto'), "aria-label": t('AccessibilityBar.RetornarTamanhoPadraoTexto') },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFont }),
                        react_1.default.createElement("span", { "aria-hidden": "true", className: "so_para_leitores_tela" }, t('AccessibilityBar.RetornarTamanhoPadrao')))),
                react_1.default.createElement("li", { className: "opt-icon opt-libras" },
                    react_1.default.createElement("a", { href: "http://www.vlibras.gov.br", target: "_blank", accessKey: "0", title: t('AccessibilityBar.IrParaOSiteVlibras'), className: "0", rel: "nofollow" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSignLanguage }),
                        react_1.default.createElement("span", { "aria-hidden": "true", className: "so_para_leitores_tela" }, t('AccessibilityBar.AcessivelEmLibras')))),
                react_1.default.createElement("li", { className: "pl-5" },
                    react_1.default.createElement(reactstrap_1.CustomInput, { id: "select-language-top-accessibility", type: "select", value: lang, className: "bkcinza3 branco b-none rad10 s12", onChange: e => {
                            changeLang(e.target.value);
                        } },
                        react_1.default.createElement("option", { value: "pt", label: "Idioma Portugu\u00EAs" }),
                        react_1.default.createElement("option", { value: "en", label: "English Language" }),
                        react_1.default.createElement("option", { value: "es", label: "Lengua Espa\u00F1ola" }))))) : (react_1.default.createElement("li", null,
                react_1.default.createElement("a", { onClick: handleClickShowOptions, href: `#${t('AccessibilityBar.MostrarOpcoesDeAcessibilidade').toLowerCase()}`, accessKey: "1" }, t('AccessibilityBar.MostrarOpcoesDeAcessibilidade'))))))));
};
const mapStateToProps = (state) => ({
    instituicaoRx: state.instituicao.data,
    acessibilidadeRx: state.pageConfig.acessibilidade,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_router_dom_1.withRouter)(AccessibilityBar));
